import Divider from '@material-ui/core/Divider';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import React from 'react';

import Tooltip from 'retired/Tooltip';
import { grayish, gray3, lightGray } from 'utils/color-styles';

export interface SummarySegmentProps {
  title?: string;
  value?: string;
  additionalInfo?: string;
  tooltipText?: string;
  content?: JSX.Element | string;
  last?: boolean;
  flexContentContainerStyles?: React.CSSProperties;
}

export const SummarySegment = ({
  title,
  value,
  additionalInfo,
  tooltipText,
  content,
  last,
  flexContentContainerStyles,
}: SummarySegmentProps) => (
  <div style={{ paddingLeft: 16, paddingRight: 16 }}>
    <div
      style={
        flexContentContainerStyles || {
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          overflowX: 'scroll',
        }
      }
    >
      <div
        style={{
          width: '100%',
          marginBottom: last ? 0 : 12,
        }}
      >
        {title && (
          <div
            style={{
              marginTop: 12,
              marginBottom: 12,
              fontSize: 12,
              lineHeight: '12px',
            }}
          >
            {title}
          </div>
        )}
        {value && (
          <div
            style={{
              fontSize: 14,
              fontFamily: 'Graphik',
              fontWeight: 500,
              lineHeight: '14px',
            }}
          >
            {value}
          </div>
        )}
        {content}
      </div>
      {tooltipText && (
        <Tooltip title={tooltipText}>
          <InfoOutlinedIcon
            style={{
              width: 20,
              height: 20,
              color: grayish,
            }}
          />
        </Tooltip>
      )}
    </div>
    {additionalInfo && (
      <div
        style={{
          fontSize: 10,
          color: gray3,
          textAlign: 'right',
        }}
      >
        {additionalInfo}
      </div>
    )}
    {!last && <Divider style={{ backgroundColor: lightGray }} />}
  </div>
);

SummarySegment.defaultProps = {
  title: null,
  value: null,
  additionalInfo: null,
  tooltipText: null,
  content: null,
  last: false,
};
